import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";
import {Response} from "@QUERIES/types";

interface CouponByEvent {
	couponNo: string;
	couponNm: string;
	discDiviCd: string;
	discRate: number;
	discAmt: number;
	validityDday: string;
	validityDiviCd: string;
	validityFrDt: string;
	validityToDt: string;
	goodsPriceCd: string;
	goodsPriceFr: number;
	remainCnt: number; // 선착순 잔여 수량
	fcfsYn: string; // 선착순 여부
	downYn?: string; // 다운로드 여부 (로그인 시, N 은 다운 받은상태, Y 는 다운 받지 않은 상태)
	issueFrDt: string; // 발급 시작일시
	multiUseYn: string; // 중복 쿠폰 사용 가능 여부(Y | N)
}

/** ```
 * 쿠폰 리스트 조회 by event
 *   `/pkg/coupon/by-event/${evCd}`
 *   `/pkg/coupon/by-event/${evCd}?webCustNo=${webCustNo}`
 * parameter
 *   `evCd` 행사코드
 *   `webCustNo?` 회원 일련번호 (로그인 시)
 * ```*/
const key = `useCouponByEvent`;
const getPath = (evCd: string): string | null => {
	if (!evCd) return null;
	return `${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/coupon/by-event/${evCd}`;
};

const useCouponByEvent = (
	evCd: string,
	webCustNo?: string,
	options?: Partial<UseQueryOptions<Response<CouponByEvent[]>, Error>>,
) =>
	useQuery({
		queryKey: [key, getPath(evCd), webCustNo ?? null],
		queryFn: () =>
			useConfigureAxios({
				url: getPath(evCd),
				params: webCustNo ? {webCustNo} : undefined,
			}).then(r => r.data),
		staleTime: 0,
		gcTime: 0,
		...options,
	});

export default useCouponByEvent;
export {getPath, key};
export type {CouponByEvent};
